import { motion } from "framer-motion";
import {
  Shield,
  Clock,
  Users,
  Headphones,
  Award,
  Zap,
} from "lucide-react";

const reasons = [
  { icon: Shield, title: "Seguridad garantizada", desc: "Unidades con revision tecnica al dia, GPS y seguros completos." },
  { icon: Clock, title: "Puntualidad", desc: "Respetamos horarios y planificamos cada detalle del recorrido." },
  { icon: Users, title: "Atencion personalizada", desc: "Cada cliente recibe un servicio adaptado a sus necesidades." },
  { icon: Headphones, title: "Soporte 24/7", desc: "Estamos disponibles todos los dias del ano para asistirte." },
  { icon: Award, title: "25+ anos de experiencia", desc: "Trayectoria comprobada en transporte turistico de calidad." },
  { icon: Zap, title: "Flota moderna", desc: "Vehiculos equipados con la ultima tecnologia y confort." },
];

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.1 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

export default function PorQueElegirnos() {
  return (
    <section
      className="py-20 md:py-32 bg-[#0D1525]"
      data-testid="por-que-elegirnos-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <span className="text-[#3DD9E8] text-sm font-bold uppercase tracking-[0.3em] font-body">
            Nuestras ventajas
          </span>
          <h2 className="font-heading text-4xl md:text-6xl text-white uppercase tracking-tight mt-3">
            Por que elegirnos
          </h2>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {reasons.map((r, i) => {
            const Icon = r.icon;
            return (
              <motion.div
                key={i}
                className="group flex gap-5 p-6 border-l-2 border-transparent hover:border-[#D0162A] transition-colors duration-300"
                variants={itemVariants}
                data-testid={`reason-${i}`}
              >
                <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-[#151e32] group-hover:bg-[#D0162A]/10 transition-colors duration-300">
                  <Icon className="text-[#D0162A] group-hover:text-[#3DD9E8] transition-colors duration-300" size={26} />
                </div>
                <div>
                  <h3 className="font-heading text-xl text-white uppercase tracking-wide mb-2">
                    {r.title}
                  </h3>
                  <p className="text-gray-400 font-body text-sm font-light leading-relaxed">
                    {r.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
